import { getCustomers, createCustomer, updateCustomer, deleteCustomer, resetCustomer } from "@/services/customer.svc" 
 
 const defaultState = () => ({
  customers: [],
  headers: [
    {
      text: 'Company',
      value: 'Company',
      sortable: true,
    },
    {
      text: 'Phone',
      value: 'Phone',
      sortable: false,
    },
    {
      text: 'Email',
      value: 'Email',
      sortable: false,
    },
    {
      text: 'Address',
      value: 'Address',
      sortable: false,
    },
    {
      text: 'City,State,Zip',
      value: 'CityStateZip',
      sortable: false,
    },
    {
      text: 'Actions',
      value: 'actions',
      sortable: false
    }
  ]
 })
 
 export default {
  namespaced: true,
  state: defaultState(),

  actions: {
    async setCustomers({ commit }, showAll = false) {
      const customers = await getCustomers(showAll)
      commit('SET_CUSTOMERS', customers)
    },

    async addCustomer(_, payload) {
      return await createCustomer(payload)
    },

    async removeCustomer(_, id) {
      return await deleteCustomer(id)
    },

    async resetCustomerAction(_, id) {
      return await resetCustomer(id)
    },

    async editCustomer(_, { id, data }) {
      return await updateCustomer(id, data)
    }
  },

  getters: {
    customers: (state) => state.customers,
    headers: (state) => state.headers,
    readOnlyHeaders: (state) => state.headers.filter(h => h.text !== 'Actions'),
    customerDropdown: (state) => state.customers
      .map(c => ({ ID: c.ID, CustomerName: c.Company }))
      .filter(c => c.CustomerName.length > 0)
      .sort((a,b) => a.CustomerName.trim().localeCompare(b.CustomerName.trim())),
    getCustomerById: (state) => (id) => state.customers.find(c => c.ID === id)
  },

  mutations: {
    SET_CUSTOMERS(state, payload) {
      state.customers = payload
    }
  }
 }